import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var AddMultipleAdminCtrl = function (fn, er, token, ids, finalArray) {

	
	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},

	};
	var data = finalArray;

	axios
		.post(ApiConfig.url.ADD_MULTIPLE_ADMIN, data, config)
		.then(function (result) {
			fn(result.data, result.status)
		})
		.catch(function (error) {
			er(error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { AddMultipleAdminCtrl };